import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { MetricCatalogResponse } from "@/interfaces/v2Analytics";
import { sanitizeMetricsCatalog } from "./sanitizeMetricsCatalog";

export interface MetricsCatalogState {
  /**
   * The metric catalog from `GET /v2/metrics/catalog`. null until the
   * bootstrap-time fetch resolves. The catalog is a hard dependency:
   * bootstrapDataStatus is only marked fetched once it is present.
   *
   * AI Visibility is stored from `modules` only (root `aiVisibility` is
   * ignored); nested Recommends sub-metrics are stripped on ingest.
   */
  catalog: MetricCatalogResponse | null;
}

const initialState: MetricsCatalogState = {
  catalog: null,
};

const metricsCatalogSlice = createSlice({
  name: "metricsCatalog",
  initialState,
  reducers: {
    setMetricsCatalog: (
      state,
      action: PayloadAction<MetricCatalogResponse | null>,
    ) => {
      state.catalog = sanitizeMetricsCatalog(action.payload);
    },
  },
});

export const { setMetricsCatalog } = metricsCatalogSlice.actions;
export default metricsCatalogSlice.reducer;
